// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col {
  width: 25%;
}

.mobile-view-button {
  padding-left: unset !important;
}

.view-btn {
  --padding-start: 0.2rem !important;
  --padding-end: 0.2rem !important;
}
@media screen and (min-width: 576px) {
  .view-btn {
    --padding-start: unset !important;
    --padding-end: unset !important;
  }
}

@media screen and (max-width: 576px) {
  .mobile-view-font {
    font-size: 0.6rem !important;
  }
}

@media screen and (max-width: 576px) {
  ion-button {
    font-size: 16px !important;
  }
}
@media screen and (max-width: 385px) {
  ion-button {
    font-size: 11px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/transaction-list/transaction-list.component.scss"],"names":[],"mappings":"AACA;EACI,UAAA;AAAJ;;AAEA;EACI,8BAAA;AACJ;;AACA;EACI,kCAAA;EACA,gCAAA;AAEJ;AAAI;EAJJ;IAKQ,iCAAA;IACA,+BAAA;EAGN;AACF;;AACI;EADJ;IAEQ,4BAAA;EAGN;AACF;;AACI;EADJ;IAEQ,0BAAA;EAGN;AACF;AAFI;EAJJ;IAKQ,0BAAA;EAKN;AACF","sourcesContent":["\r\n.col {\r\n    width:25%;\r\n}\r\n.mobile-view-button{\r\n    padding-left: unset !important;\r\n}\r\n.view-btn {\r\n    --padding-start: 0.2rem !important;\r\n    --padding-end: 0.2rem !important;\r\n\r\n    @media screen and (min-width: 576px) {\r\n        --padding-start: unset !important;\r\n        --padding-end: unset !important;\r\n    }\r\n}\r\n\r\n.mobile-view-font {\r\n    @media screen and (max-width: 576px) {\r\n        font-size: 0.60rem !important;\r\n    }\r\n}\r\n\r\nion-button {\r\n    @media screen and (max-width: 576px) {\r\n        font-size: 16px !important\r\n    }  \r\n    @media screen and (max-width: 385px) {\r\n        font-size: 11px !important\r\n    }  \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
